module.exports = __webpack_public_path__ + "static/media/27OCHA6.64a2896c.jpg";